import { lazy } from 'react';

const ShiftsPage = lazy(() => import('./ShiftsPage'));

export { ShiftsPage };
